// extracted by mini-css-extract-plugin
export default {"couponitemcomp__selected":"Hv6_u_couponitemcomp__selected"};